/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Account } from '../models/Account';
import { Pagination } from '../models/Pagination';

export class ListAccountsResponse {
  'accounts': Array<Account>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "accounts",
      "baseName": "accounts",
      "type": "Array<Account>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListAccountsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

